import React from 'react'
import { SEARCH_MATCH_HIGHLIGHT } from './constants'

export function getSearchFormattedText(text: string, searchString?: string) {
  if (!searchString) {
    // user is not searching by anything
    return text
  }
  const elements: React.ReactNode[] = []
  const lower = text.toLowerCase()
  const lowerSearch = searchString.toLowerCase()

  let start = 0
  let matchInd = lower.indexOf(lowerSearch)

  while (matchInd !== -1) {
    // push text before the match
    if (matchInd > start) {
      elements.push(text.slice(start, matchInd))
    }

    // push highlighted match
    const spanProps = {
      style: { backgroundColor: SEARCH_MATCH_HIGHLIGHT, color: '#353751' },
      key: matchInd,
    }
    elements.push(
      React.createElement(
        'span',
        spanProps,
        text.slice(matchInd, matchInd + searchString.length)
      )
    )

    start = matchInd + searchString.length
    matchInd = lower.indexOf(lowerSearch, start)
  }

  // push any remaining text after last match
  if (start < text.length) {
    elements.push(text.slice(start))
  }

  return React.createElement('span', {}, elements)
}
